// -----------------------------------------------------------------------------
// Programmverwaltung
// -----------------------------------------------------------------------------

import * as generalUtility from '../utility/generalUtility';
import swal from '../../../js/sweetalert.min.js'; // eslint-disable-line new-cap

const init = () => {
  if ($('.js-body').hasClass('js-body-programmverwaltung') === false) {
    return;
  }

  initEventListeners();

  // Initialen Zustand setzen
  investorIsn();
};

/**
 * Event-Listeners initialisieren
 */
const initEventListeners = () => {
  const trans = generalUtility.getJsonFromHtml('.js-body-programmverwaltung #trans');

  // Formular speichern
  $('.saveData').click(function (e) {
    e.preventDefault();

    if (saveData() === true) {
      document.forms.frmProgrammverwaltung.submit();
    } else {
      swal(trans.bitte_mindestens_ein_programm_waehlen); // eslint-disable-line new-cap
    }
  });

  // Programmübersicht: Investor + ISN
  $(document).on('change', 'input[name="i2"]', function () {
    investorIsn();
  });

  /**
   * User kann sich entweder für KI-Anbieter oder KI-Nachfrager anmelden
   */
  $(document).on('click', 'input[data-program="ki"]', function () {
    $('input[data-program="ki"]').not(this).prop('checked', false);
  });
};

/**
 * Formular speichern
 *
 * @returns {boolean}
 */
const saveData = () => {
  let programme = 0;

  $.each($('input:checked'), function () {
    programme += parseInt($(this).val(), 10);
  });

  if (programme === 0) {
    return false;
  }

  $('#programme').val(programme);
  return true;
};

/**
 * Aktiviert ISN-Kachel in Programmübersicht, abhängig davon ob Investor sich für i2 angemeldet hat oder nicht
 */
const investorIsn = () => {
  const $container = $('.js-app-programmverwaltung');

  // Abbruch, falls User kein Investor ist
  if ($container.attr('data-role') !== 'I') {
    return;
  }

  const $checkboxIsn = $container.find('input[name="isn"]');
  const $checkboxI2 = $container.find('input[name="i2"]');

  if ($checkboxI2.is(':checked')) {
    $checkboxIsn.prop('disabled', false);
    $container.find('.js-card-isn').css('opacity', 1);
  } else {
    $checkboxIsn.prop('checked', false);
    $checkboxIsn.prop('disabled', true);
    $container.find('.js-card-isn').css('opacity', 0.5);
  }
};

export {
  init
};
